import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const crossFadeImages = document.querySelectorAll('.crossfade');
  const crossFadeTimelines = Object.create({});

  crossFadeImages.forEach((image, index) => {
    let fadingImage = image.querySelector(':scope > :last-child');

    crossFadeTimelines[index] = gsap.timeline({
      scrollTrigger: {
        trigger: image,
        start: "center 60%",
        end: "bottom center",
        toggleActions: "play none none reverse"
      }
    });
    crossFadeTimelines[index].fromTo(fadingImage, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 1.5
    })
  })
})
